import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { useRef, useState } from 'react';
import { ICategoryToIconMap } from '../categoryToIconMap';

export const useSingleToggle = ({
    categories,
}: {
    categories: Array<ICategoryToIconMap>;
}) => {
    let urlCategory;
    const resetFiltersRef = useRef<HTMLDivElement>(null);

    if (HAS_WINDOW) {
        const searchParams = new URLSearchParams(window.location.search);
        const currentParam = decodeURIComponent(
            searchParams.get('category') ?? '',
        );

        urlCategory = categories.find(
            (category) => category.searchParam === currentParam,
        );
    }

    const [selectedCategory, setToggled] = useState<ICategoryToIconMap>(
        urlCategory ?? categories[0],
    );

    const handleToggled = (idx: number) => {
        // Default to select the 'All' chip when unselecting a chip
        if (categories[idx] === selectedCategory) {
            idx = 0;
        }

        if (HAS_WINDOW) {
            const searchParams = new URLSearchParams(window.location.search);

            if (idx === 0) {
                searchParams.delete('category');

                resetFiltersRef.current?.scrollTo({ left: 0 });
            } else {
                searchParams.set('category', categories[idx].searchParam);
            }

            const newUrl = `${window.location.pathname}?${searchParams}`;
            window.history.replaceState({}, '', newUrl);
        }

        setToggled(() => categories[idx]);
    };

    return { handleToggled, selectedCategory, resetFiltersRef };
};
